import { render, staticRenderFns } from "./addressEdit.vue?vue&type=template&id=65acce51&scoped=true"
import script from "./addressEdit.vue?vue&type=script&lang=js"
export * from "./addressEdit.vue?vue&type=script&lang=js"
import style0 from "./addressEdit.vue?vue&type=style&index=0&id=65acce51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65acce51",
  null
  
)

export default component.exports